import { CustomerDetails } from '../../models/customer/customer-details.interface';
import { mockCustomerAddressDetails } from './customer-address-details.mock';
import { mockCustomerTelephoneDetails } from './customer-telephone-details.mock';

export const mockCustomerDetails: CustomerDetails = {
  billingAddress: mockCustomerAddressDetails,
  email: 'bob@ross.com',
  firstName: 'Bob',
  lastName: 'Ross',
  phone: mockCustomerTelephoneDetails,
};
